import { routes } from '../../../config';
import { NameableEntity, NavigationElement } from '../../shared/models';
import { concatUrl, createPath, createPathId } from '../../shared/utils';
import { Brand } from '../models';

interface CatalogueContent {
    category?: NameableEntity<number>;
    parentCategory?: NameableEntity<number>;
    universe: NameableEntity<number>;
}

export const getParentNavigation = (
    data: CatalogueContent,
    parentNavigationTree?: NavigationElement,
): NavigationElement | undefined => {
    // TODO : voir comment récupérer le segment univers proprement
    let parentPath = parentNavigationTree ? parentNavigationTree.path : '';
    if (parentPath && !parentPath.endsWith('univers')) {
        parentPath = concatUrl([parentNavigationTree ? parentNavigationTree.path : '', 'univers']);
    }

    let additionalParentNavigationTree: NavigationElement | undefined;

    if (data.universe) {
        additionalParentNavigationTree = {
            name: data.universe.name,
            path: concatUrl([parentPath, createPathId(createPath(data.universe.name), `${data.universe.id}`)]),
            parent: parentNavigationTree,
        };

        parentPath = concatUrl([parentPath, createPath(data.universe.name)]);
    }

    if (data.parentCategory) {
        const parentCategoryNavigationTree: NavigationElement = {
            name: data.parentCategory.name,
            path: concatUrl([
                parentPath,
                createPathId(createPath(data.parentCategory.name), `${data.parentCategory.id}`),
            ]),
            parent: additionalParentNavigationTree || parentNavigationTree,
        };

        parentPath = concatUrl([parentPath, createPath(data.parentCategory.name)]);

        additionalParentNavigationTree = parentCategoryNavigationTree;
    }

    if (data.category) {
        const categoryNavigationTree: NavigationElement = {
            name: data.category.name,
            path: concatUrl([parentPath, createPathId(createPath(data.category.name), `${data.category.id}`)]),
            parent: additionalParentNavigationTree || parentNavigationTree,
        };

        parentPath = concatUrl([parentPath, createPath(data.category.name)]);

        additionalParentNavigationTree = categoryNavigationTree;
    }

    return additionalParentNavigationTree || parentNavigationTree;
};

export const getBrandUrl = (brand: Brand): string => {
    if (brand) {
        return `${routes.catalogue.brand}/${createPathId(createPath(brand.name), brand.id)}`;
    }
    return '';
};
